import { $api } from "../generated/client";

/** Enqueue a full catalog sync for a shop on the CATALOG_FULL_SYNC queue. */
export function useTriggerCatalogFullSync() {
  return $api.useMutation("post", "/super-admin/catalog-sync/{shopId}/full");
}

/** Enqueue a delta catalog sync for a shop on the CATALOG_DELTA_SYNC queue. */
export function useTriggerCatalogDeltaSync() {
  return $api.useMutation("post", "/super-admin/catalog-sync/{shopId}/delta");
}

/**
 * Probe productCount on every eligible shop (1 GQL call / shop).
 * Backend runs batches in background, returns 202 immediately.
 */
export function useProbeAllCatalogCounts() {
  return $api.useMutation("post", "/super-admin/catalog-sync/probe-all-counts");
}

/** Probe productCount for a single shop. Waits synchronously for result. */
export function useProbeCatalogShopCount() {
  return $api.useMutation(
    "post",
    "/super-admin/catalog-sync/{shopId}/probe-count",
  );
}
